"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredefinedFilterToJSON = exports.PredefinedFilterFromJSONTyped = exports.PredefinedFilterFromJSON = exports.PredefinedFilter = void 0;
/**
 *
 * @export
 */
exports.PredefinedFilter = {
    Canvas: 'CANVAS',
    StandaloneVideo: 'STANDALONE_VIDEO'
};
function PredefinedFilterFromJSON(json) {
    return PredefinedFilterFromJSONTyped(json, false);
}
exports.PredefinedFilterFromJSON = PredefinedFilterFromJSON;
function PredefinedFilterFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PredefinedFilterFromJSONTyped = PredefinedFilterFromJSONTyped;
function PredefinedFilterToJSON(value) {
    return value;
}
exports.PredefinedFilterToJSON = PredefinedFilterToJSON;
